<template>
  <div class="container">
    <h5>{{ accountName }}</h5>
    <form>
      <label for="report-for-month">
        Mês e Ano
        <input
          v-model="selectedPeriod"
          type="month"
          name="report-for-month"
          id="report-for-month"
          required
        />
      </label>
    </form>
    <p class="label">Montantes da conta para o período selecionado</p>
    <ul class="account-totals">
      <li class="account-total">
        <span class="total-name">entradas</span>
        <span class="total-value ti">{{ incomeTotal }} {{ accountCurrency }}</span>
      </li>
      <li class="account-total">
        <span class="total-name">saídas</span>
        <span class="total-value te">{{ expensesTotal }} {{ accountCurrency }}</span>
      </li>
      <li class="account-total">
        <span class="total-name">disponível</span>
        <span class="total-value ta">{{ accountBalance.toFixed(2) }} {{ accountCurrency }}</span>
      </li>
    </ul>
    <p class="label">Clique numa operação para editá-la</p>
    <ul v-if="hasOperations" class="account-report-detailed">
      <li v-for="(o, index) in operationsToList" :key="index">
        <span class="account-report-date">
          <p>{{formatTheDate(o.date)}}</p>
          <p>{{o.total.toFixed(2)}}</p>
        </span>
        <ul class="operations-list">
          <li class="operation" v-for="operation in o.operationsWithSigns" :key="operation.id">
            <p @click="goToAccountOperationEdit" :id="operation.id">
              {{operation.operationCategory.name}}
            </p>
            <span>{{operation.amount.toFixed(2) + " " + operation.currency}}</span>
          </li>
        </ul>
        <div class="operation-divider">
          <span class="yellow"></span>
          <span class="red"></span>
          <span class="blue"></span>
          <span class="green"></span>
          <span class="yellow"></span>
        </div>
      </li>
    </ul>
    <p v-else class="message-info">Esta conta não possui nenhum histórico de operações.</p>
    <AppButton
      @click.native="goToOperationRegister"
      class="add-operation"
      text="Adicionar Operação"
    />
    <p @click="goToRoute" id="/contas" class="cancel-button" role="button">Voltar ao início</p>
    <TheBottomNav :linksList="linksList" @click.native="changeRoute"/>
  </div>
</template>
<script>
import AppButton from "@/components/AppButton.vue";
import TheBottomNav from "@/components/TheBottomNavbar.vue";

export default {
  name: "TheAccountTransactions",
  components: {
    AppButton,
    TheBottomNav
  },
  created() {
    this.getCurrentMonthAndYear();
  },
  beforeMount() {
    this.setAccountData();
  },
  data() {
    return {
      selectedPeriod: null,
      accountOwnerID: null,
      accountData: {},
      accountID: null,
      accountName: null,
      accountBalance: null,
      accountCurrency: null,
      accountOperations: [],
      linksList: []
    };
  },
  methods: {
    changeRoute(e) {
      if (e.srcElement.id) {
        const { srcElement: { id } } = e;
        if (this.$route.name !== id) {
          this.$router.push({ name: id,
            params: { accountID: this.accountID,
              accountData: this.$route.params.accountData } });
        }
      }
    },
    goToRoute(e) {
      const nextRoute = e.srcElement.id;
      if (nextRoute) {
        const currentRoute = this.$route.path;

        if (currentRoute !== nextRoute) this.$router.push(nextRoute);
      }
    },
    setAccountData() {
      if (this.$route.params.accountData) {
        this.accountData = this.$route.params.accountData;
        this.accountID = this.$route.params.accountData.id;
        this.accountOwnerID = this.$route.params.accountData.user_id;
        this.accountName = this.$route.params.accountData.account_name;
        this.accountBalance = this.$route.params.accountData.current_balance;
        this.accountCurrency = this.$route.params.accountData.currency.short_name;
        this.accountOperations = this.$route.params.accountData.operations;
        this.linksList = [
          {
            routeName: "accountTransactions",
            name: "Transações",
            icon: "transactions",
            path: `/contas/${this.accountID}/transaccoes`
          },
          {
            routeName: "accountReport",
            name: "Relatório",
            icon: "report",
            path: `/contas/${this.accountID}/relatorios`
          },
          {
            routeName: "accountSettings",
            name: "Dados da conta",
            icon: "settings",
            path: `/contas/${this.accountID}/definicoes`
          }
        ];
      } else this.$router.push({ name: "accounts" });
    },
    getCurrentMonthAndYear() {
      const year = new Date().getFullYear();
      const month = `0${new Date().getMonth() + 1}`;
      if (month.length === 3) {
        const fixedMonth = month.slice(1, 3);
        this.selectedPeriod = `${year}-${fixedMonth}`;
      } else this.selectedPeriod = `${year}-${month}`;
    },
    goToOperationRegister() {
      const currentRoutePath = this.$route.path;
      const nextRoutePath = `/contas/${this.$route.params.accountID}/adicionar-operacao`;

      if (currentRoutePath !== nextRoutePath) {
        this.$router.push({
          name: "accountOperationRegister",
          params: { accountData: this.$route.params.accountData }
        });
      }
    },
    sortArrayOfObjects(array, attribute) {
      const arrayCopy = [...array];
      return arrayCopy.sort((a, b) => {
        if (a[attribute] < b[attribute]) return 1;
        if (a[attribute] > b[attribute]) return -1;
        return 0;
      });
    },
    newArrayOf(array, attribute) {
      return array.map(v => v[attribute]);
    },
    customIndexOf(array, value) {
      const indexOf = [];
      array.forEach((el, index) => {
        if (el === value) {
          indexOf.push(index);
        }
      });
      const [firstOcurrence] = indexOf;
      return firstOcurrence;
    },
    removeDuplicates(array) {
      return this.sortArrayOfObjects(array).filter(
        (el, index, originalArray) => this.customIndexOf(originalArray, el) === index
      );
    },
    groupOperationsByDate(arrayOfDates, arrayOfOperations) {
      const groupedOperationsByDate = arrayOfDates.map(d => {
        const operationsOnThisDate = arrayOfOperations.filter(v => v.effective_by === d);

        const operationsWithSigns = operationsOnThisDate.map(v => {
          const newAmount = v.operation_type === "expense" ? -Math.abs(v.amount) : v.amount;

          const operation = v;
          operation.amount = newAmount;

          return operation;
        });

        const total = operationsWithSigns.reduce((acc, v) => acc + v.amount, 0);

        return {
          date: d,
          total,
          operationsWithSigns
        };
      });

      return groupedOperationsByDate;
    },
    formatTheDate(date, formatOption) {
      const defaultOption = { weekday: "long", year: "numeric", month: "long", day: "numeric" };
      if (formatOption === undefined) return new Date(date).toLocaleDateString("pt-PT", defaultOption);
      return new Date(date).toLocaleDateString("pt-PT", formatOption);
    },
    changeBalance(changeType, amount, originalValue) {
      if (changeType === "increase") return (originalValue + amount);
      return (originalValue - amount);
    },
    goToAccountOperationEdit(e) {
      const { id } = e.srcElement;
      const { accountData } = this;
      const { operations } = accountData;
      const currentRoute = this.$route.path;
      const nextRoute = `/contas/${this.accountID}/editar-operacao`;
      const operationToEdit = operations.filter(o => o.id === parseInt(id, 10))[0];
      const { operation_type: operationType, amount } = operationToEdit;

      if (nextRoute !== currentRoute) {
        this.$router.push({ name: "accountOperationEdit",
          params: {
            accountID: this.accountID, operationID: parseInt(id, 10), accountData } });
      }
    }
  },
  computed: {
    hasOperations() {
      const accountOperationsListLength = this.accountOperations.length;

      if (accountOperationsListLength > 0) return true;
      return false;
    },
    arraysIntoElements() {
      const arraysOfOperations = this.operationsToList.map(array => array.operationsWithSigns);
      const operations = [];
      arraysOfOperations.forEach(array => {
        operations.push(...array);
      });
      return operations;
    },
    incomeTotal() {
      if (this.hasOperations) {
        const operations = this.arraysIntoElements;
        const incomes = operations.filter(v => v.operation_type === "income");
        return incomes.map(v => v.amount).reduce((acc, val) => acc + val, 0).toFixed(2);
      }
      return 0;
    },
    expensesTotal() {
      if (this.hasOperations) {
        const operations = this.arraysIntoElements;
        const expenses = operations.filter(v => v.operation_type === "expense");
        return Math.abs(expenses.map(v => v.amount).reduce((acc, val) => acc + val, 0)).toFixed(2);
      }
      return 0;
    },
    operationsToList() {
      const sortedOperations = this.sortArrayOfObjects(this.accountOperations, "effective_by");
      const arrayOfDates = this.newArrayOf(sortedOperations, "effective_by");
      const nonDuplicates = this.removeDuplicates(arrayOfDates);
      const groupedOperations = this.groupOperationsByDate(nonDuplicates, sortedOperations);
      const filteredOperations = groupedOperations.filter(v => {
        const periodYear = new Date(this.selectedPeriod).getFullYear();
        const periodMonth = new Date(this.selectedPeriod).getMonth();

        const date = new Date(v.date);
        const mth = date.getMonth();
        const y = date.getFullYear();

        if (periodMonth === mth) {
          if (periodYear === y) {
            return true;
          }
        }
        return false;
      });
      return filteredOperations;
    }
  }
};
</script>

<style scoped>
h5 {
  margin-bottom: 1.6rem;
}

label,
.label {
  color: var(--color-tertiary);
}

.label {
  font-size: 0.75rem;
}

form {
  margin-bottom: 1.6rem;
}

input {
  width: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  padding-bottom: 4.8rem;
}

.account-totals {
  display: flex;
  justify-content: space-between;
  margin: 0.8rem 0 1.6rem 0;
}

.account-total {
  background-color: var(--color-white);
  border-radius: 5px;
  padding: 0.4rem 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.15));
}

.total-name {
  color: var(--color-primary);
  font-size: 0.75rem;
}

.total-name,
.total-value {
  text-align: center;
}

.ti {
  color: var(--color-secondary);
}

.te {
  color: var(--color-senary);
}

.ta {
  color: var(--color-tertiary);
}

.account-report-detailed {
  background-color: var(--color-white);
  width: 100%;
  padding: 0.8rem;
  margin-bottom: 2rem;
  margin-top: 0.8rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.account-report-detailed :last-child .operation-divider {
  display: none;
}

.operation {
  cursor: pointer;
}

.operation,
.account-report-date {
  display: flex;
  justify-content: space-between;
}

.account-report-date p {
  font-size: 0.75rem;
  color: var(--color-tertiary);
}

.operation {
  color: var(--color-primary);
}

.operation-divider {
  display: flex;
  height: 2px;
  margin: 0.8rem 0;
}

.yellow {
  background-color: var(--color-quinary);
  width: 22%;
}

.blue {
  background: var(--color-primary);
  width: 15%;
}

.green {
  background-color: var(--color-secondary);
  width: 25%;
}

.red {
  background-color: var(--color-senary);
  width: 18%;
}

.add-operation {
  background-color: var(--color-primary);
  color: var(--color-quaternary);
  margin: 0 auto 1.6rem auto;
}

.cancel-button {
  color: var(--color-secondary);
  text-align: center;
  margin: 0 auto 2rem auto;
  cursor: pointer;
}

.message-info {
  color: var(--color-senary);
  font-size: 1rem;
  text-align: center;
  margin: 0.8rem 0 1.6rem 0;
}
</style>
